// extracted by mini-css-extract-plugin
export default {"summary":"TaskCopyIssueFilePage_summary__4YNKk","title":"TaskCopyIssueFilePage_title__CrQSs","navigationIcon":"TaskCopyIssueFilePage_navigationIcon__mSBeQ"};